// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Ghoz","errorLogs":"styles_errorLogs__1i6Mk"};